<template>
  <v-container>
    <div class="pb-2" v-if="popularItems && popularItems.length">
      <div class="text-caption">{{ $t("message.popular") }}</div>
      <div class="text-center">
        <template v-for="i in popularItems">
          <v-badge :key="'popular_' + i._id" color="accent" v-if="i.size"
            :content="i.size.length == 1 ? i.size.slice(0, 1).toUpperCase() : i.size.slice(0, 2).toUpperCase()" overlap>
            <v-avatar size="50" :key="'popular_' + i._id">
              <ImageDisplay v-if="i.image" :src="i.image" />
              <div v-else class="text-h5">
                {{ i.name.slice(0, 2).toUpperCase() }}
              </div>
            </v-avatar>
          </v-badge>
          <v-btn v-else @click="initCheckout(i)" fab :key="'popular_' + i._id" class="mr-1">
            <v-avatar size="50" :key="'popular_' + i._id">
              <ImageDisplay v-if="i.image" :src="i.image" />
              <div v-else class="text-h5">
                {{ i.name.slice(0, 2).toUpperCase() }}
              </div>
            </v-avatar>
          </v-btn>
        </template>
      </div>
    </div>
    <v-divider></v-divider>
    <v-card-actions :disabled="cart.length <= 0">
      <v-btn @click="confirmationDialog = true;" elevation="0" block :disabled="cart.length == 0" color="primary"
        outlined>
        {{ $t('message.pay') }} <b>{{ displayTotal }}</b>
      </v-btn>
    </v-card-actions>
    <v-card-actions class="text-caption pt-2 pb-0 mb-0 pl-0 ml-0 pr-0 mr-0">
      {{ $t("message.products") }}
      <v-spacer></v-spacer>
      <v-btn v-if="cart.length > 0" color="error" x-small text @click="cart = []">{{ $t("message.clear_cart") }}</v-btn>
    </v-card-actions>
    <v-row>
      <v-col v-for="product in products" :key="product._id" cols="6" sm="3">
        <v-card outlined class="product-card d-flex flex-column">
          <v-card-title class="text-center text-truncate pb-0 mb-0">
            {{ product.name }}</v-card-title>
          <v-card-actions class="">
            <span class="text-overine"><b>{{ currencySymbol }}{{ product.amountDecimal }}</b></span>
            <span v-if="product.size" class="ml-1">({{ product.size }})</span>
            <v-spacer></v-spacer>
            <span v-if="product.availableQuantity" class="grey--text text-caption">({{ $t("message.x_left",
              [product.availableQuantity])
            }})</span>
          </v-card-actions>
          <div class="text-center">
            <v-avatar size="80" style="border: 1px solid gray">
              <ImageDisplay v-if="product.image" :src="product.image" />
              <ImageDisplay v-else :src="academyImage" />
            </v-avatar>
          </div>
          <v-card-text class="description-text flex-grow-1 pt-1">
            {{ product.description }}
          </v-card-text>
          <v-card-actions v-if="!product.soldOut">
            <v-btn icon @click="addToCart(product)" elevation="0" color="primary">
              <v-icon class="mr-1">mdi-cart-plus</v-icon>
            </v-btn>
            <v-chip v-if="productCounts[product._id]" color="secondary" small class="ml-1">{{
              productCounts[product._id]
              }}</v-chip>
            <v-spacer></v-spacer>
            <v-btn icon v-if="productCounts[product._id]" @click="removeFromCart(product)" class="ml-2" elevation="0">
              <v-icon class="mr-1" color="error">mdi-cart-minus</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-spacer></v-spacer>
            <v-btn color="error" text small><v-icon>mdi-alert</v-icon>{{ $t("message.out_of_stock") }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog width="70%" :persiste="true" v-model="handlingCharges">
      <v-card class="pa-0 pt-2" elevation="0" outlined>
        <v-card-text class="pa-0">
          <v-progress-linear striped height="50" indeterminate color="success"></v-progress-linear>
        </v-card-text>
        <v-card-actions class="mt-2 mb-2">
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="cancelTransaction()">{{ $t('message.cancel')
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmationDialog">
      <v-card outlined>
        <v-list dense>
          <v-list-item dense v-for="i in cart" :key="'item_car_' + i._id">
            <v-list-item-avatar>
              <ImageDisplay v-if="i.image" :src="i.image" />
              <ImageDisplay v-else :src="academyImage" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ i.name }}</v-list-item-title>
              <v-list-item-subtitle>
                x{{ productCounts[i._id] }} {{ currencySymbol }}{{ i.amountDecimal }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-text class="text-h3 text-center">
          TOTAL: {{ displayTotal }}
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" @click="initCheckout()" outlined color="primary">
            {{ $t("message.confirm") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="confirmationDialog = false">
            {{ $t("message.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AcademyService from "@/services/AcademyService";
import PaymentsService from "@/services/PaymentsService";

export default {
  data() {
    return {
      loading: true,
      currencySymbol: '$',
      currency: 'usd',
      academyImage: null,
      popularItems: [],
      confirmationDialog: false,
      products: [],
      cart: [],
      handlingCharges: false,
    };
  },
  created() {
    AcademyService.myaAcademyProducts(this.$store.state.userManagedAcademy)
      .then((data) => {
        if (data.success) {
          this.currencySymbol = data.data.currencySymbol;
          this.currency = data.data.currency;
          this.popularItems = data.data.popular;
          this.products = data.data.products;
          this.academyImage = data.data.academyImage;
        }
      });
  },
  components: {
  },
  watch: {
  },
  computed: {
    displayTotal() {
      return this.currencySymbol + this.calculateTotal();
    },
    productCounts() {
      // This creates an object like: { 'productId1': 2, 'productId2': 1 }
      return this.cart.reduce((acc, item) => {
        acc[item._id] = item.purchaseCount;
        return acc;
      }, {});
    }
  },
  methods: {
    cancelTransaction() {
      this.handlingCharges = false;
    },
    initCheckout(product) {
      let items = this.setupItems(product);
      if (this.handlingCharges)
        return;
      this.handlingCharges = true;
      const postData = {
        items: items,
        processedBy: "user",
      };
      PaymentsService.initSelfServicePurchase(this.$store.state.userManagedAcademy, postData)
        .then((data) => {
          if (data.transaction) {
            this.navigateTo({
              name: "checkout",
              params: { transactionId: data.transaction },
            });
          } else {
            this.showAlert("error", this.$t("message.invalid_transaction"));
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e.response.data && e.response.data.message)
            this.showAlert("error", e.response.data.message);
          else
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    setupItems(product) {
      let items = [];
      if (product) {
        let image = this.userImg(this.academyImage);
        if (product.image) image = this.userImg(product.image);
        items.push({
          name: product.name,
          image: product.image ? product.image : this.academyImage,
          description:
            !product.description || product.description == "" ? " " : product.description,
          images: [image],
          amount: product.amount,
          amountDecimal: product.amountDecimal,
          currency: this.currency,
          quantity: 1,
          product: product._id,
        });
      } else {
        for (const i of this.cart) {
          let image = this.userImg(this.academyImage);
          if (i.image) image = this.userImg(i.image);
          items.push({
            name: i.name,
            image: i.image ? i.image : this.academyImage,
            description:
              !i.description || i.description == "" ? " " : i.description,
            images: [image],
            amount: i.amount,
            amountDecimal: i.amountDecimal,
            currency: this.currency,
            quantity: this.productCounts[i._id],
            product: i._id,
          });
        }
      }
      return items;
    },
    addToCart(product) {
      const cartItem = this.cart.find(item => item._id === product._id);

      if (cartItem) {
        const newCount = (cartItem.purchaseCount || 0) + 1;
        this.$set(cartItem, 'purchaseCount', newCount);
      } else {
        const newCartItem = { ...product };
        this.$set(newCartItem, 'purchaseCount', 1);
        this.cart.push(newCartItem);
      }
    },
    removeFromCart(product) {
      const cartItemIndex = this.cart.findIndex(item => item._id === product._id);
      if (cartItemIndex === -1) {
        return;
      }
      const cartItem = this.cart[cartItemIndex];
      if (cartItem.purchaseCount > 1) {
        this.$set(cartItem, 'purchaseCount', cartItem.purchaseCount - 1);
      } else {
        this.cart.splice(cartItemIndex, 1);
      }
    },
    calculateTotal() {
      let total = 0;
      for (const i of this.cart) {
        total += i.amountDecimal * i.purchaseCount;
      }
      return total;
    },
  }
};
</script>

<style scoped>
.product-card {
  height: 100%;
}

/* This is the magic for multi-line truncation */
.description-text {
  /* Set a fixed height for the description area */
  height: 50px;
  /* Adjust this value to fit your design (e.g., 3 lines of text) */

  /* Required for line clamping */
  display: -webkit-box;
  -webkit-box-orient: vertical;

  /* The number of lines to show before truncating */
  -webkit-line-clamp: 3;
  /* Adjust this number for more or fewer lines */

  /* Hide the overflowing text */
  overflow: hidden;

  /* Add the ellipsis (...) */
  text-overflow: ellipsis;
}
</style>
